import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  CreateOdPayload,
  CreateOutdoorDutyResponse,
  GetOutdoorDutyResponseById,
  // OutdoorDutyParams,
  OutdoorDutyResponse,
  UpdateStatusPayload,
} from "@/interface/od.interface";

export const OdService = {

  getList: async (path: string): Promise<OutdoorDutyResponse> => {
  return callApi<OutdoorDutyResponse>(
    `${API_ENDPOINT.od}?${path}`,
    { method: "GET" }
  );
},

  create: async (
    payload: CreateOdPayload,
  ): Promise<CreateOutdoorDutyResponse> => {
    return callApi<CreateOutdoorDutyResponse>(API_ENDPOINT.od, {
      method: "POST",
      data: payload,
    });
  },

  delete: async (id: string, siteId?: string): Promise<GetOutdoorDutyResponseById> => {
    const url = `${API_ENDPOINT.od}/${id} ${siteId ? `?siteId=${siteId}` : ""}`;
    return callApi<GetOutdoorDutyResponseById>(url, { method: "DELETE" });
  },

  getById: async (id: string , siteId?: string): Promise<GetOutdoorDutyResponseById> => {
    const url = `${API_ENDPOINT.od}/${id} ${siteId ? `?siteId=${siteId}` : ""}`;
    return callApi<GetOutdoorDutyResponseById>(url, { method: "GET" });
  },

  updateStatus: async (
    id: string,
    payload: UpdateStatusPayload,
  ): Promise<GetOutdoorDutyResponseById> => {
    const url = `${API_ENDPOINT.od}/${id}/status`;
    return callApi<GetOutdoorDutyResponseById>(url, {
      method: "PUT",
      data: payload,
    });
  },

  update: async (id: string, payload: CreateOdPayload): Promise<GetOutdoorDutyResponseById> => {
  const url = `${API_ENDPOINT.od}/${id}`;
  return callApi<GetOutdoorDutyResponseById>(url, {
    method: "PUT",
    data: payload,
  });
},
};
